// useImpressionLog 는 shared/model 로 이관됨. 하위호환 re-export.
export { useImpressionLog } from '@/shared/model'
